module.exports = __webpack_public_path__ + "static/media/bg-white-kinedu-educators-en.ce9023f4.svg";